export const categories = [
  {
    "id": 1,
    "title": "Вакцинация, регистрация, чипирование"
  },
  {
    "id": 2,
    "title": "Терапия"
  },
  {
    "id": 3,
    "title": "Хирургия"
  },
  {
    "id": 4,
    "title": "Кастрация (стоимость указана с учетом расходных материалов и медикаментов)"
  },
  {
    "id": 5,
    "title": "Хирургические операции (стоимость указана без учете стоимости препаратов и расходных материалов)"
  },
  {
    "id": 6,
    "title": "Ортопедия, травматология"
  },
  {
    "id": 7,
    "title": "Стоматология"
  },
  {
    "id": 8,
    "title": "Офтальмология"
  },
  {
    "id": 9,
    "title": "Диагностические исследования"
  },
  {
    "id": 10,
    "title": "Стационар"
  },
  {
    "id": 11,
    "title": "Эвтаназия, кремация"
  }
]
